import { NgModule } from '@angular/core';
import { CoreModule } from '../../core/core.module';
import { CircleInfoComponent } from './circle-info/circle-info.component';
import { CurrencyPipe, DatePipe, DecimalPipe, LowerCasePipe, PercentPipe, TitleCasePipe, UpperCasePipe } from '@angular/common';
import { ToolbarComponent } from './toolbar/toolbar.component';
import { PlaylistAutocompleteComponent } from './utils/playlist-autocomplete.component';
import { PlaylistAutocompleteChipsComponent } from './utils/playlist-autocomplete-chips.component';
import { UploadButtonComponent } from './utils/upload-button.component';
import { StatusBoxComponent } from './utils/status-box.component';
import { StatusFilterBarComponent } from './utils/status-filter-bar.component';
import { AdvancedFiltersComponent } from './filters/advanced-filters.component';
import { AdvancedFilterExtraFieldComponent } from './filters/advanced-filter-extra-field.component';
import { DateSelectorComponent } from './date-selector/date-selector.component';
import { DateRangeChooserComponent } from './date-selector/date-range-chooser.component';
import { CsTableColumnCommonService } from './table/cs-table-column-common.service';
import { PublisherAutocompleteComponent } from './utils/publisher-autocomplete.component';
import { PublisherAutocompleteChipsComponent } from './utils/publisher-autocomplete-chips.component';
import { DomainAutocompleteComponent } from './utils/domain-autocomplete.component';
import { DomainAutocompleteChipsComponent } from './utils/domain-autocomplete-chips.component';
import { DomainAutocompleteChipsInputComponent } from './utils/domain-autocomplete-chips-input.component';
import { EmbedAutocompleteComponent } from './utils/embed-autocomplete.component';
import { EmbedAutocompleteChipsComponent } from './utils/embed-autocomplete-chips.component';
import { ImageUploadPreviewComponent } from './utils/image-upload-preview/image-upload-preview.component';
import { MatTableColVisComponent } from './table/mat-table-col-vis.component';
import { CardFiltersComponent } from './cards/card-filters.component';
import { ToolbarPublisherComponent } from './toolbar/toolbar-publisher/toolbar-publisher.component';
import { ContentOwnerAutocompleteComponent } from './utils/content-owner-autocomplete.component';
import { PlaylistIngestFeedDialogComponent } from '../../modules/playlists/playlist-ingest-feed-dialog/playlist-ingest-feed-dialog.component';
import { HighchartsChartModule } from 'highcharts-angular';
import { SearchControlComponent } from './search-control/search-control.component';
import { DurationPipe } from './pipes/duration.pipe';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { CategoriesAutocompleteChipsComponent } from './utils/categories-autocomplete-chips.component';
import { CategoriesAutocompleteComponent } from './utils/categories-autocomplete.component';
import { CategoriesMultiSelectComponent } from './utils/categories-multi-select.component';
import { ChannelsAutocompleteComponent } from './utils/channels-autocomplete.component';
import { CategoriesAutocompleteChipsInputComponent } from './utils/categories-autocomplete-chips-input.component';
import { VideosTableComponent } from '../../modules/videos/videos-table/videos-table.component';
import { ContentOwnerAutocompleteChipsComponent } from './utils/content-owner-autocomplete-chips.component';
import { VideoUploadPreviewComponent } from './utils/video-upload-preview/video-upload-preview.component';
import { UsersSharedTableComponent } from 'src/app/modules/content-owner/details/users/users-shared-table/users-shared-table.component';
import { DocumentsSharedTableComponent } from 'src/app/modules/content-owner/details/documents/documents-shared-table/documents-shared-table.component';
import { DocumentsSharedUploadDocumentDialogComponent } from 'src/app/modules/content-owner/details/documents/documents-shared-table/documents-shared-upload-document-dialog/documents-shared-upload-document-dialog.component';
import { PubDashboardDomainsChartComponent } from 'src/app/modules/publisher/dashboard/pub-dashboard-domains/pub-dashboard-domains-chart/pub-dashboard-domains-chart.component';
import { MetricSummaryCardComponent } from 'src/app/modules/publisher/dashboard/metric-summary-card/metric-summary-card.component';
import { RemovableMessageCardComponent } from 'src/app/modules/publisher/dashboard/removable-message-card/removable-message-card.component';
import { ContentByteDialogComponent } from 'src/app/modules/publishers/publisher-details/content-byte/content-byte-dialog/content-byte-dialog.component';
import { DpAutocompleteComponent } from './utils/dp-autocomplete.component';
import { DpAutocompleteChipsComponent } from './utils/dp-autocomplete-chips';
import { BundleIdAutocompleteComponent } from './utils/bundle-id-autocomplete.component';
import { BundleIdAutocompleteChipsComponent } from './utils/bundle-id-autocomplete-chips.component';
import { FlagAutocompleteComponent } from './utils/flags-autocomplete.component';
import { FlagAutocompleteChipsComponent } from './utils/flags-autocomplete-chips';
import { VjsPlayerComponent } from 'src/app/modules/playlists/playlist-video-preview/vjs-player.component';
import { TagsAutocompleteComponent } from './utils/tags-autocomplete.component';
import { TagsAutocompleteChipsComponent } from './utils/tags-autocomplete-chips';
import { GenresAutocompleteComponent } from './utils/genres-autocomplete.component';
import { GenresAutocompleteChipsComponent } from './utils/genres-autocomplete-chips';
import { ArtistsAutocompleteComponent } from './utils/artists-autocomplete.component';
import { ArtistsAutocompleteChipsComponent } from './utils/artists-autocomplete-chips';
import { NetworkAutocompleteChipsComponent } from './utils/network-autocomplete-chips.component';
import { NetworkAutocompleteComponent } from './utils/network-autocomplete.component';
import { PlacementsAutocompleteComponent } from './utils/placements-autocomplete';
import { DpDetailsConnectionsComponent } from 'src/app/modules/demand/details/connections/dp-details-connections.component';
import { MultipleTextDialog } from './multiple-text-input-dialog/multiple-text-dialog.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { PageLoader } from './loaders/page-loader/page-loader.component';
import { MasterTableComponent } from './master-table/master-table.component';
import { MasterTablePipe } from './master-table/pipes/master-table.pipe';
import { FileSelectComponent } from './file-select/file-select.component';
import { ChipsInputComponent } from './chips-input/chips-input.component';
import { SuccessRedirectDialogComponent } from './success-redirect-dialog/success-redirect-dialog.component';
import { DeleteDialogComponent } from './delete-dialog/delete-dialog.component';
import { ConnectionsAutocompleteComponent } from './utils/dp-connections-autocomplete.component';
import { PlacementsAutocompleteChipsComponent } from './utils/placement-autocomplete-chips.component';
import { ConnectionsAutocompleteChipsComponent } from './utils/dp-connection-autocomplete-chips.component';
import {
  IabCategoriesAutocompleteChipsInputComponent
} from './utils/iab-categories-autocomplete-chips-input.component';
import { UsersAutocompleteComponent } from './utils/users-autocomplete.component';
import { UsersAutocompleteChipsComponent } from './utils/users-autocomplete-chips.components';
import { CreativesAutocompleteComponent } from './utils/creatives-autocomplete';
import { PlatformAutocompleteComponent } from './utils/platform-autocomplete.component';
import { PlatformAutocompleteChipsComponent } from './utils/platform-autocomplete-chips.component';
import { GenresAutocompleteChipsInputComponent } from './utils/genres-autocomplete-chips-input.component';
import { GeolocationsCountryAutocompleteComponent } from './utils/geolocation-country-autocomplete';
import { GeolocationsCountryAutocompleteChipsComponent } from './utils/geolocation-country-autocomplete-chips';
import { EndpointGeneratorMacroDialogComponent } from './endpoint-generator-macros/endpoint-generator-macro-dialog.component';
import { LineItemsAutocompleteComponent } from './utils/line-items-autocomplete.component';
import { LineItemsAutocompleteChipsComponent } from './utils/line-items-autocomplete-chips.component';
import { ChangelogDialogComponent } from './changelog-dialog/changelog-dialog.component';
import { SimpleMatTableColVisComponent } from './table/simple-mat-table-col-vis.component';
import { TitleCaseSplittedPipe } from './pipes/title-case-splitted.pipe';
import { A2vTagsAutocompleteChipsInputComponent } from './utils/a2v-tags-autocomplete-chips';
import { AdsTxtUrlStatusTableComponent } from './ads-txt-url-status-table/ads-txt-url-status-table.component';
import { CustomUploadMenuButtonComponent } from './upload-menu-button/custom-upload-menu-button.component';
import { AddAppDialogComponent } from './add-app-dialog/add-app-dialog.component';
import { SegmentAutocompleteChipsComponent } from './utils/segment-autocomplete-chips.component';
import { SegmentAutocompleteComponent } from './utils/segment-autocomplete.component';
import { MultipleFileSelectComponent } from './multiple-file-select/multiple-file-select.component';
import { PublisherAutocompleteChipsInputComponent } from './utils/publisher-autocomplete-chips-input.component';
import { OrdersAutocompleteChipsInputComponent } from './utils/orders-autocomplete-chips-input.component';
import { DealsAutocompleteComponent } from './utils/deals-autocomplete.components';
import { DealsAutocompleteChipsComponent } from './utils/deals-autocomplete-chips.component';
import { MetroCodesComponent } from './metro-codes/metro-codes.component';
import { GrapeshotAutocompleteChipsInputComponent } from './utils/grapeshot-autocomplete-chips-input.component';
import { MASAutocompleteChipsInputComponent } from './utils/mas-autocomplete-chips-input.component';
import { AppsAutocompleteComponent } from './utils/apps-autocomplete.component';
import { AppsAutocompleteChipsComponent } from './utils/apps-autocomplete-chips.component';
import { DmaAutocompleteChipsInputComponent } from './utils/dma-autocomplete-chips.components';
import { EpgChannelAutocompleteChipsInputComponent } from './utils/epg-channels-autocomplete-chips-input.component';
import { EpgTitleAutocompleteChipsInputComponent } from './utils/epg-titles-autocomplete-chips-input.components';
import { EpgGenreAutocompleteChipsInputComponent } from './utils/epg-genres-autocomplete-chips-input.component';
import { EpgRatingAutocompleteChipsInputComponent } from './utils/epg-ratings-autocomplete-chips-input.component';
import { SidenavButtonComponent } from './sidenav-button/sidenav-button.component';
import { DynamicCreativesAutocompleteChipsInputComponent } from './utils/dynamic-creatives-autocomplete-chips-input.component';
import { AdvertiserAutocompleteChipsInputComponent } from './utils/advertiser-autocomplete-chips-input';
import { TargetingAutocompleteChipsInputComponent } from './utils/targeting-autocomplete-chips-input.component';
import { UnderscoreSplittedPipe } from './pipes/underscore-splitted.pipe';
import { ChangePasswordDialogComponent } from './change-password-dialog/change-password-dialog.component';
import { EpgKeywordsAutocompleteChipsInputComponent } from './utils/epg-keywords-autocomplete-chips-input.component';
import { KeywordPackagesAutocompleteChipsInputComponent } from './utils/keyword-packages-autocomplete-chips-input.component';
import { EpgGenreAutocompleteComponent } from './utils/epg-genre-autocomplete.component';
import { IabCategoriesAutocompleteComponent } from './utils/iab-categories-autocomplete.component';
import { AdvertiserAutocompleteComponent } from './utils/advertiser-autocomplete.component';
import { FreeInputAutocompleteChipsInputComponent } from './utils/free-input-autocomplete-chips-input.component copy';
import { ContentLanguageAutocompleteChipsInputComponent } from './utils/epg-languages-autocomplete-chips-input.component';
import { CapitalizeFirstPipe } from './pipes/capitalize-first.pipe';
import { AsyncStateComponent } from './async-state/async-state.component';
import { BreadcrumbsComponent } from './breadcrumbs/breadcrumbs.component';
import { StatCardComponent } from './stat-card/stat-card.component';
import { ChartCardComponent } from './chart-card/chart-card.component';
import { QuickActionCardComponent } from './quick-action-card/quick-action-card.component';
import { SectionTabsComponent } from './section-tabs/section-tabs.component';
import { InventoryTabsComponent } from './inventory-tabs/inventory-tabs.component';
import { PartnersTabsComponent } from './partners-tabs/partners-tabs.component';
import { DemandTabsComponent } from './demand-tabs/demand-tabs.component';
import { CampaignsTabsComponent } from './campaigns-tabs/campaigns-tabs.component';
import { AnalyticsTabsComponent } from './analytics-tabs/analytics-tabs.component';
import { A2vTabsComponent } from './a2v-tabs/a2v-tabs.component';
import { ContentTabsComponent } from './content-tabs/content-tabs.component';
import { MomentsTabsComponent } from './moments-tabs/moments-tabs.component';
import { ConsentBannerComponent } from './consent-banner/consent-banner.component';


@NgModule({
    declarations: [
        ToolbarComponent,
        PlaylistAutocompleteComponent,
        PlaylistAutocompleteChipsComponent,
        UploadButtonComponent,
        StatusBoxComponent,
        StatusFilterBarComponent,
        AdvancedFiltersComponent,
        AdvancedFilterExtraFieldComponent,
        DateSelectorComponent,
        DateRangeChooserComponent,
        PublisherAutocompleteComponent,
        PublisherAutocompleteChipsComponent,
        NetworkAutocompleteChipsComponent,
        NetworkAutocompleteComponent,
        BundleIdAutocompleteComponent,
        BundleIdAutocompleteChipsComponent,
        DpAutocompleteComponent,
        DpAutocompleteChipsComponent,
        FlagAutocompleteComponent,
        FlagAutocompleteChipsComponent,
        TagsAutocompleteComponent,
        TagsAutocompleteChipsComponent,
        GenresAutocompleteComponent,
        GenresAutocompleteChipsComponent,
        ArtistsAutocompleteComponent,
        ArtistsAutocompleteChipsComponent,
        PlaylistAutocompleteChipsComponent,
        DomainAutocompleteComponent,
        DomainAutocompleteChipsComponent,
        DomainAutocompleteChipsInputComponent,
        EmbedAutocompleteComponent,
        EmbedAutocompleteChipsComponent,
        ImageUploadPreviewComponent,
        VideoUploadPreviewComponent,
        MatTableColVisComponent,
        CardFiltersComponent,
        ToolbarPublisherComponent,
        ContentOwnerAutocompleteComponent,
        PlaylistIngestFeedDialogComponent,
        ContentByteDialogComponent,
        SearchControlComponent,
        DurationPipe,
        CapitalizeFirstPipe,
        ConfirmDialogComponent,
        CategoriesAutocompleteChipsComponent,
        CategoriesAutocompleteComponent,
        CategoriesMultiSelectComponent,
        PlacementsAutocompleteComponent,
        UsersSharedTableComponent,
        DocumentsSharedTableComponent,
        DocumentsSharedUploadDocumentDialogComponent,
        VideosTableComponent,
        ConfirmDialogComponent,
        DeleteDialogComponent,
        ContentOwnerAutocompleteChipsComponent,
        ChannelsAutocompleteComponent,
        IabCategoriesAutocompleteChipsInputComponent,
        CategoriesAutocompleteChipsInputComponent,
        RemovableMessageCardComponent,
        MetricSummaryCardComponent,
        PubDashboardDomainsChartComponent,
        DpDetailsConnectionsComponent,
        VjsPlayerComponent,
        MultipleTextDialog,
        PageLoader,
        MasterTableComponent,
        MasterTablePipe,
        CircleInfoComponent,
        FileSelectComponent,
        ChipsInputComponent,
        SuccessRedirectDialogComponent,
        ConnectionsAutocompleteComponent,
        PlacementsAutocompleteChipsComponent,
        ConnectionsAutocompleteChipsComponent,
        UsersAutocompleteComponent,
        UsersAutocompleteChipsComponent,
        CreativesAutocompleteComponent,
        PlatformAutocompleteComponent,
        PlatformAutocompleteChipsComponent,
        GenresAutocompleteChipsInputComponent,
        GeolocationsCountryAutocompleteComponent,
        GeolocationsCountryAutocompleteChipsComponent,
        EndpointGeneratorMacroDialogComponent,
        LineItemsAutocompleteComponent,
        LineItemsAutocompleteChipsComponent,
        ChangelogDialogComponent,
        PublisherAutocompleteChipsInputComponent,
        SimpleMatTableColVisComponent,
        TitleCaseSplittedPipe,
        UnderscoreSplittedPipe,
        A2vTagsAutocompleteChipsInputComponent,
        AdsTxtUrlStatusTableComponent,
        CustomUploadMenuButtonComponent,
        AddAppDialogComponent,
        SegmentAutocompleteComponent,
        SegmentAutocompleteChipsComponent,
        MultipleFileSelectComponent,
        OrdersAutocompleteChipsInputComponent,
        DealsAutocompleteComponent,
        DealsAutocompleteChipsComponent,
        MetroCodesComponent,
        GrapeshotAutocompleteChipsInputComponent,
        MASAutocompleteChipsInputComponent,
        AppsAutocompleteComponent,
        AppsAutocompleteChipsComponent,
        DmaAutocompleteChipsInputComponent,
        EpgChannelAutocompleteChipsInputComponent,
        EpgTitleAutocompleteChipsInputComponent,
        ContentLanguageAutocompleteChipsInputComponent,
        EpgGenreAutocompleteChipsInputComponent,
        EpgRatingAutocompleteChipsInputComponent,
        SidenavButtonComponent,
        DynamicCreativesAutocompleteChipsInputComponent,
        AdvertiserAutocompleteChipsInputComponent,
        TargetingAutocompleteChipsInputComponent,
        ChangePasswordDialogComponent,
        EpgKeywordsAutocompleteChipsInputComponent,
        KeywordPackagesAutocompleteChipsInputComponent,
        EpgGenreAutocompleteComponent,
        IabCategoriesAutocompleteComponent,
        AdvertiserAutocompleteComponent,
        FreeInputAutocompleteChipsInputComponent,
        AsyncStateComponent,
        BreadcrumbsComponent,
        StatCardComponent,
        ChartCardComponent,
        QuickActionCardComponent,
        SectionTabsComponent,
        InventoryTabsComponent,
        PartnersTabsComponent,
        DemandTabsComponent,
        CampaignsTabsComponent,
        AnalyticsTabsComponent,
        A2vTabsComponent,
        ContentTabsComponent,
        MomentsTabsComponent,
        ConsentBannerComponent
    ],
    imports: [CoreModule, HighchartsChartModule, MatProgressSpinnerModule],
    providers: [
        DatePipe,
        DecimalPipe,
        TitleCasePipe,
        LowerCasePipe,
        UpperCasePipe,
        PercentPipe,
        CurrencyPipe,
        DurationPipe,
        CapitalizeFirstPipe,
        CsTableColumnCommonService
    ],
    exports: [
        ConsentBannerComponent,
        ToolbarComponent,
        PlaylistAutocompleteChipsComponent,
        PlaylistAutocompleteComponent,
        UploadButtonComponent,
        StatusBoxComponent,
        StatusFilterBarComponent,
        AdvancedFiltersComponent,
        AdvancedFilterExtraFieldComponent,
        DateSelectorComponent,
        DateRangeChooserComponent,
        ImageUploadPreviewComponent,
        VideoUploadPreviewComponent,
        PublisherAutocompleteComponent,
        PublisherAutocompleteChipsComponent,
        NetworkAutocompleteChipsComponent,
        NetworkAutocompleteComponent,
        BundleIdAutocompleteComponent,
        BundleIdAutocompleteChipsComponent,
        DpAutocompleteComponent,
        DpAutocompleteChipsComponent,
        FlagAutocompleteComponent,
        FlagAutocompleteChipsComponent,
        TagsAutocompleteComponent,
        TagsAutocompleteChipsComponent,
        GenresAutocompleteComponent,
        GenresAutocompleteChipsComponent,
        ArtistsAutocompleteComponent,
        ArtistsAutocompleteChipsComponent,
        PlaylistAutocompleteChipsComponent,
        DomainAutocompleteComponent,
        DomainAutocompleteChipsComponent,
        DomainAutocompleteChipsInputComponent,
        EmbedAutocompleteComponent,
        EmbedAutocompleteChipsComponent,
        MatTableColVisComponent,
        CardFiltersComponent,
        ToolbarPublisherComponent,
        ContentOwnerAutocompleteComponent,
        PlaylistIngestFeedDialogComponent,
        ContentByteDialogComponent,
        SearchControlComponent,
        DurationPipe,
        CapitalizeFirstPipe,
        VideosTableComponent,
        ConfirmDialogComponent,
        CategoriesAutocompleteChipsComponent,
        CategoriesAutocompleteComponent,
        CategoriesMultiSelectComponent,
        PlacementsAutocompleteComponent,
        DeleteDialogComponent,
        UsersSharedTableComponent,
        DocumentsSharedTableComponent,
        DocumentsSharedUploadDocumentDialogComponent,
        ContentOwnerAutocompleteChipsComponent,
        ChannelsAutocompleteComponent,
        IabCategoriesAutocompleteChipsInputComponent,
        CategoriesAutocompleteChipsInputComponent,
        RemovableMessageCardComponent,
        MetricSummaryCardComponent,
        PubDashboardDomainsChartComponent,
        DpDetailsConnectionsComponent,
        VjsPlayerComponent,
        MultipleTextDialog,
        PageLoader,
        MasterTableComponent,
        CircleInfoComponent,
        FileSelectComponent,
        ChipsInputComponent,
        ConnectionsAutocompleteComponent,
        PlacementsAutocompleteChipsComponent,
        ConnectionsAutocompleteChipsComponent,
        UsersAutocompleteComponent,
        UsersAutocompleteChipsComponent,
        CreativesAutocompleteComponent,
        PlatformAutocompleteComponent,
        PlatformAutocompleteChipsComponent,
        GenresAutocompleteChipsInputComponent,
        GeolocationsCountryAutocompleteComponent,
        GeolocationsCountryAutocompleteChipsComponent,
        LineItemsAutocompleteComponent,
        LineItemsAutocompleteChipsComponent,
        PublisherAutocompleteChipsInputComponent,
        SimpleMatTableColVisComponent,
        TitleCaseSplittedPipe,
        UnderscoreSplittedPipe,
        A2vTagsAutocompleteChipsInputComponent,
        AdsTxtUrlStatusTableComponent,
        CustomUploadMenuButtonComponent,
        AddAppDialogComponent,
        SegmentAutocompleteComponent,
        SegmentAutocompleteChipsComponent,
        OrdersAutocompleteChipsInputComponent,
        DealsAutocompleteComponent,
        DealsAutocompleteChipsComponent,
        MetroCodesComponent,
        GrapeshotAutocompleteChipsInputComponent,
        MASAutocompleteChipsInputComponent,
        AppsAutocompleteComponent,
        AppsAutocompleteChipsComponent,
        DmaAutocompleteChipsInputComponent,
        EpgChannelAutocompleteChipsInputComponent,
        EpgTitleAutocompleteChipsInputComponent,
        ContentLanguageAutocompleteChipsInputComponent,
        EpgGenreAutocompleteChipsInputComponent,
        SidenavButtonComponent,
        EpgRatingAutocompleteChipsInputComponent,
        DynamicCreativesAutocompleteChipsInputComponent,
        AdvertiserAutocompleteChipsInputComponent,
        TargetingAutocompleteChipsInputComponent,
        EpgKeywordsAutocompleteChipsInputComponent,
        KeywordPackagesAutocompleteChipsInputComponent,
        EpgGenreAutocompleteComponent,
        IabCategoriesAutocompleteComponent,
        AdvertiserAutocompleteComponent,
        FreeInputAutocompleteChipsInputComponent,
        AsyncStateComponent,
        BreadcrumbsComponent,
        StatCardComponent,
        ChartCardComponent,
        QuickActionCardComponent,
        SectionTabsComponent,
        InventoryTabsComponent,
        PartnersTabsComponent,
        DemandTabsComponent,
        CampaignsTabsComponent,
        AnalyticsTabsComponent,
        A2vTabsComponent,
        ContentTabsComponent,
        MomentsTabsComponent
    ]
})
export class SharedComponentsModule {}
